export default "__VITE_ASSET__B65rIFF7__"